export const OPTIMIZELY_UPLOAD_TYPES = {
    MULTIPLE: 'multiple',
    SINGLE: 'single'
};

export const OPTIMIZELY_IMAGE_TYPES = {
    PDF: 'pdf',
    PPTX: 'pptx'
};

export const OPTIMIZELY_PUBLISH_SETTINGS = 'optimizely_publish_settings';

export const ANSELL_FIELD_SLUGS = {
    PRODUCT_BRAND: 'product-brand',
    BRAND_STYLE: 'brand-style',
    INDUSTRIES_VERTICALS: 'industries-verticals'
};

export const ANSELL_DATA_KEYS = {
    MARKETING_PRODUCT_BRAND: 'marketing_product_brand',
    BRAND_STYLE_ITEM: 'brand_style_item',
    SUB_INDUSTRIES_EN_US: 'sub_industries_en_us'
};
